module.exports = __webpack_public_path__ + "media/components/page-quote/calendar-ba04b26e498f990d2f0708bb12fc9403.png";